<template>
    <div class="interaction-ui-bottom">

        <div class="interaction-ui-round" v-for = "(value, key) in bottomUIObj" :key="key + Math.random()">
            <div @click="clickIcon(value)">
                <div class="interaction-des-text">
                    <span v-if="null != value.description && '' !== value.description">{{value.description}}</span>
                </div>

                <div class="interaction-icon">
                    <font-awesome-icon :icon="value.icon" />
                </div>

                <div class="interaction-title">
                    {{value.text}}
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>

import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";

const props = defineProps(["bottomUIObj"])
const emits = defineEmits(["clickIcon"])

function clickIcon(obj){
    emits("clickIcon", obj)
}

</script>

<style scoped>
.interaction-ui-bottom {
    position: absolute;
    text-align: center;
    display: flex;
    bottom: 8vh;
    align-items: flex-start;
    justify-content: center;
    width: 100%;
    flex-wrap: wrap;
}

@media screen and (max-width: 520px) {
    .interaction-ui-round {
        opacity: 1;
        animation: showInteractionUiRound 0.35s ease-out;
        user-select: none;
        padding-left: 2.5vw;

    }
}

@media screen and (min-width: 520px) {
    .interaction-ui-round {
        opacity: 1;
        animation: showInteractionUiRound 0.35s ease-out;
        user-select: none;
        padding-left: 10px;

    }
}

@keyframes showInteractionUiRound {
    0% {
        opacity: 0.1;
        transform: scale(0.3);
    }

    100% {
        opacity: 1;
        transform: scale(1);
    }
}

@media screen and (min-width: 520px) {
    .interaction-ui-round .interaction-des-text {
        line-height: 2;
        height: 2em;
        color: #fefefe;
        font-size: 14px;
        width: 116px;
        text-shadow: 1px 1px 0 #2d3e4f, -1px -1px 0 #2d3e4f, 1px -1px 0 #2d3e4f, -1px 1px 0 #2d3e4f;
        user-select: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .interaction-ui-round .interaction-icon {
        width: 96px;
        height: 96px;
        border-radius: 50%;
        background: rgb(255, 255, 255);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 40px;
        margin-left: 10px;
        margin-right: 10px;
        user-select: none;
        box-sizing: border-box;
    }

    .interaction-ui-round .interaction-title {
        color: #fefefe;
        font-weight: 600;
        margin-top: 15px;
        font-size: 20px;
        width: 116px;
        text-shadow: 1px 1px 0 #2d3e4f, -1px -1px 0 #2d3e4f, 1px -1px 0 #2d3e4f, -1px 1px 0 #2d3e4f;
        user-select: none;

    }
}

@media screen and (max-width: 520px) {
    .interaction-ui-round .interaction-des-text {
        line-height: 2;
        height: 2em;
        color: #fefefe;
        margin-top: 15px;
        font-size: 12px;
        width: 20vw;
        text-shadow: 1px 1px 0 #2d3e4f, -1px -1px 0 #2d3e4f, 1px -1px 0 #2d3e4f, -1px 1px 0 #2d3e4f;
        user-select: none;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .interaction-ui-round .interaction-icon {
        width: 20vw;
        height: 20vw;
        border-radius: 50%;
        background: rgb(255, 255, 255);
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 40px;
        /*margin-left: 10px;*/
        /*margin-right: 10px;*/
        user-select: none;
        box-sizing: border-box;
    }

    .interaction-ui-round .interaction-title {
        color: #fefefe;
        font-weight: 600;
        margin-top: 15px;
        font-size: 12px;
        width: 20vw;
        text-shadow: 1px 1px 0 #2d3e4f, -1px -1px 0 #2d3e4f, 1px -1px 0 #2d3e4f, -1px 1px 0 #2d3e4f;
        user-select: none;

    }
}
</style>